import {Component, Inject, OnInit} from '@angular/core';
import {NavigationEnd, Router, RoutesRecognized} from '@angular/router';
import {filter} from 'rxjs/internal/operators';
import {DOCUMENT} from '@angular/common';
import {IdleService} from './shared/services/idle/idle.service';
import {NgbModal} from './shared/components/modal/modal';
import {TimeoutComponent} from './shared/modules/timeout/timeout.component';
import {idleConfig, externalUrls} from './shared/config/config/config.constants';
import {LoginService} from './shared/services/login/login.service';
import {queryParamToObject, isMobileApp, removeElement} from './shared/utils/util';
import {CoreService} from './shared/services/core/core.service';
import {RoutingStateService} from './shared/services/routing-state/routing-state.service';
import {UtilityCookieService} from './shared/utils/cookie/utilitycookie.service';


declare const window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'mdp-dashboard';
  loading: boolean;
  showHeaderFooter: boolean;
  showGlobalHeader: boolean = false;
  lockOut;

  constructor(@Inject(DOCUMENT) private _document,
              private _idle: IdleService,
              private _core: CoreService,
              private _auth: LoginService,
              private _modal: NgbModal,
              private _routeState: RoutingStateService,
              private _router: Router) {
    /**
     * Run a prefetch
     */
    this._core.prefetchRxHistory();
  }

  /**
   * Angular <life cycle> method
   */
  ngOnInit() {
    /**
     * Conditions for global header
     */
    let headerHdnewCookieValue;
    const headerHdnewCookieExists: boolean = UtilityCookieService.checkCookieExists('hdnew');
    if (headerHdnewCookieExists) {
      headerHdnewCookieValue = UtilityCookieService.getCookie('hdnew');
    }
    const headerHddfCookieExists: boolean = UtilityCookieService.checkCookieExists('hddf');

    this.showGlobalHeader = false;
    if (headerHddfCookieExists) {
      const headerHddfCookieValue = UtilityCookieService.getCookie('hddf');
      if (headerHddfCookieValue.toUpperCase() === 'OFF') {
        this.showGlobalHeader = false;
      } else if (headerHdnewCookieExists && headerHdnewCookieValue.toUpperCase() === 'ON') {
        this.showGlobalHeader = true;
      }
    } else if (headerHdnewCookieExists && headerHdnewCookieValue.toUpperCase() === 'ON') {
      this.showGlobalHeader = true;
    }

    const q = queryParamToObject();
    this._router.navigate(['/'], {queryParams: q, queryParamsHandling: 'merge'});
    /**
     * Run router listner
     */
    this.listenToRouterEvents();
    /**
     * Listen to authentication state
     * and orchestrate global actionsmo
     */
    this._auth.authState.subscribe(state => {
      if (state.authenticated) {
        this.showHeaderFooter = !isMobileApp();
        this.addMobileAppClass(this.showHeaderFooter);
        removeElement(this._document.querySelector('#staticHeader'));
        /**
         * Lockout settings
         */
        if (!this.lockOut) {
          this.lockOut = this._idle.watch()
            .setTimeout((idleConfig.timeoutDuration + idleConfig.idleDuration),
              idleConfig.idleDuration
            );
          this.lockOut.lockedOut.subscribe(lockedOut => {
            if (lockedOut) {
              this.presentModal(false);
              this._router.navigate(['/logout'], {skipLocationChange: true});
            }
          });
          this.lockOut.onIdelStart.subscribe(lockout => { /** do something when idle start **/
          });
          this.lockOut.beenIdle.subscribe(beenIdle => {
            if (beenIdle) {
              this.presentModal(true);
            }
          });
        }
        // refresh token
        // if auth retrieved from local, request refresh token
        if (state.mocked) {
          this._auth.refreshToken();
        }
        /**
         * run every 3 minutes
         */
        if (!this._auth.rts) {
          this._auth.rts = setInterval(() => {
            this._auth.refreshToken();
          }, (1000 * 60) * 3);
        }
      }
    });
  }

  /**
   * @returns: void
   * @description: responsible for doing general app adjustments
   */
  private listenToRouterEvents(): void {
    this._router.events.pipe(
      filter((e: any) => e instanceof RoutesRecognized || e instanceof NavigationEnd),
    ).forEach((e: any) => {
      if (e instanceof RoutesRecognized) {
        try {
          const prevRouteUrl: string = e.url
            , ignores: string[] = [];
          this._routeState.saveRouting(prevRouteUrl);
        } catch (e) {
        }
      } else if (e instanceof NavigationEnd) {
        this.scrollToTop();
      }
    });
  }

  /**
   * Scroll back to top
   */
  scrollToTop() {
    if (this._document.documentElement) {
      this._document.documentElement.scrollTop = 0;
    } else {
      this._document.body.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }

  /**
   * Warning is used to display first a warning, otherwise logout user
   */
  public presentModal(warning): void {
    this._modal.dismissAll();
    const modalRef = this._modal.open(TimeoutComponent,
      {'keyboard': true, 'size': 'lg'});
    modalRef.componentInstance.viewedInModal = true;
    // pass modal ref
    modalRef.componentInstance.modal = modalRef;
    modalRef.componentInstance.warning = warning;
    modalRef.result.then((result) => {
    }, (cancel) => {
      if (!warning) {
        window.location.href = externalUrls.origin + '/pharmacy/#/pharmacy';
        // this._idle.resetTimers();
      } else {
        this._idle.requestToStay();
      }
    });
  }

  /**
   * hide feedback sticky tab for mobile App's
   */
  addMobileAppClass(isNotApp: boolean) {
    if (isNotApp) {
      return;
    }
    const bodyNode = this._document.querySelector('body');
    if (bodyNode) {
      bodyNode.classList.add('mobile-app');
    }
  }
}
